/**
 * Created by Zed on 2019/7/23.
 */
import React from 'react';
import { render } from 'react-dom';
import './assets/style/style.scss';
import { Provider } from 'mobx-react';
import { JssProvider } from 'react-jss';
import App from "./App";
import './store';
import { rehydrate } from "rfx-core";
import { ConfigProvider } from "antd";
import zhCN from "antd/lib/locale/zh_CN";

import moment from "moment";
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const store = rehydrate();

render(
  <JssProvider classNamePrefix="Jss-">
    <Provider {...store}>
      <ConfigProvider locale={zhCN}>
        <App />
      </ConfigProvider>
    </Provider>
  </JssProvider>,
  document.getElementById('root'));

// 判断该浏览器支不支持 serviceWorker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        console.log('service-worker registed');
      })
      .catch(error => {
        console.log('service-worker registed error');
      });
  });
}
